import { Mouvement } from '@mairistem/comptabilite';
import { ErrorField } from '@mairistem/liste';
import BaseProfilEcritureMouvement from '../../../classes/mouvements/profilEcriture/Base/BaseProfilEcritureMouvement';
import { MOUVEMENT_FRONT_ERROR } from '../../../errors/mouvements/mouvementErrors';

const checkMouvement = (mouvement: Mouvement, selectedProfilEcriture: BaseProfilEcritureMouvement): ErrorField[] => {
  const errors: ErrorField[] = [];

  if (!mouvement?.identifiantBordereau) {
    errors.push({ id: 'bordereau', message: MOUVEMENT_FRONT_ERROR.MOUVEMENT_BORDEREAU });
  }

  if (!mouvement?.identifiantExercice) {
    errors.push({ id: null, message: MOUVEMENT_FRONT_ERROR.MOUVEMENT_EXERCICE });
  }

  if (!mouvement?.identifiantEntite) {
    errors.push({ id: null, message: MOUVEMENT_FRONT_ERROR.MOUVEMENT_ENTITE });
  }

  const checkImputations = mouvement?.lignes?.find((ligne) => !ligne?.identifiantImputation);
  if (checkImputations) {
    errors.push({ id: null, message: MOUVEMENT_FRONT_ERROR.MOUVEMENT_IMPUTATION });
  }

  if (selectedProfilEcriture) {
    // Gestion des erreurs en relation avec les profils d'écriture
    errors.push(...selectedProfilEcriture.check(mouvement));
  }

  return errors;
};

export default checkMouvement;
